export default __webpack_public_path__ + "media/craig.fdb37a96.jpg";